import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueSignaturePad from "vue-signature-pad";
import { store } from "./store/store";
import VueTheMask from "vue-the-mask";
import VueTour from "vue-tour";
//TEST5
require("vue-tour/dist/vue-tour.css");

Vue.use(VueTour);
Vue.use(VueTheMask);
Vue.use(VueSignaturePad);
Vue.config.productionTip = false;

new Vue({
  store: store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
